import { useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import CanvasIcon from "./CanvasIcon";
import { NODE_TYPE_GROUPS } from "./node-types";
import { ICON_PATHS, stepLook } from "./step-look";

const AddStepDialog = ({ open, onPick, onClose }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.PROCESS);
  const ADD = t("CANVAS_EDITOR.ADD_STEP", { returnObjects: true });
  const TYPE_LABELS = t("FORM.NODE_TYPES", { returnObjects: true });
  const TYPE_HINTS = t("CANVAS_EDITOR.TYPE_HINTS", { returnObjects: true });

  useEffect(() => {
    if (!open) return undefined;
    const closeOnEscape = (event) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <>
      <div className="canvas-add__backdrop" onClick={onClose} />
      <div className="canvas-add" role="dialog" aria-label={ADD.TITLE}>
        <div className="canvas-add__header">
          <div>
            <h2 className="canvas-add__title">{ADD.TITLE}</h2>
            <p className="canvas-add__hint">{ADD.HINT}</p>
          </div>
          <button
            type="button"
            className="canvas-checks__close"
            aria-label={ADD.CLOSE}
            onClick={onClose}
          >
            <CanvasIcon path={ICON_PATHS.close} strokeWidth={2} />
          </button>
        </div>
        {NODE_TYPE_GROUPS.map((group) => (
          <section key={group.key} className="canvas-add__group">
            <h3 className="canvas-add__group-title">{ADD.GROUPS[group.key]}</h3>
            <div className="canvas-add__grid">
              {group.types.map((nodeType) => {
                const look = stepLook(nodeType);
                return (
                  <button
                    key={nodeType}
                    type="button"
                    className="canvas-add__type"
                    onClick={() => onPick(nodeType)}
                  >
                    <span
                      className={`canvas-add__icon canvas-tone--${look.tone} canvas-tone-fill--${look.tone}`}
                    >
                      <CanvasIcon path={look.icon} />
                    </span>
                    <span className="canvas-add__text">
                      <strong>{TYPE_LABELS[nodeType] || nodeType}</strong>
                      <span>{TYPE_HINTS[nodeType]}</span>
                    </span>
                  </button>
                );
              })}
            </div>
          </section>
        ))}
      </div>
    </>
  );
};

AddStepDialog.propTypes = {
  open: PropTypes.bool,
  onPick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

AddStepDialog.defaultProps = {
  open: false,
};

export default AddStepDialog;
